module.exports = __webpack_public_path__ + "static/media/reshK.91d54ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/specialApplications/reshK.jpg
// module id = 220
// module chunks = 0